export default __webpack_public_path__ + "static/media/close.6611e8d1.mp3";